import React from 'react';
import { connect } from 'react-redux';

import CreateUser from './../InstallerPages/CreateUser/CreateUser';
import PinUser from './../InstallerPages/PinUser/PinUser';
import { Grid } from '@material-ui/core';
import { getFreeSystems } from '../../stores/actions/installerActions';
import { getVisibleAccounts } from '../../stores/actions/actions';
import _ from 'lodash';

interface ISettingsPanelProps {
	mobileView: boolean;
    accountCategory: string;
	getFreeSystems: () => void;
	getVisibleAccounts: () => void;
}

class SettingsPanel extends React.Component<ISettingsPanelProps> {

	componentWillMount(): void {
		this.props.getFreeSystems();
		this.props.getVisibleAccounts();
	}

	render() {
		const { mobileView, systems, accounts, accountCategory } = this.props;
        console.log('systems', systems);
        console.log('accounts', accounts);
        const filteredSystems = _.filter([...systems], { accountRole: 'administrator' });
		const sortedSystems = [...filteredSystems].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
		return (
				<Grid container spacing={2}>
					<Grid item xs={mobileView ? 12 : 6}>
						<CreateUser 
							accounts={accounts}
							systems={sortedSystems}
                            accountCategory={accountCategory}
						/>
					</Grid>
					<Grid item xs={mobileView ? 12 : 6}>
						<PinUser 
							systems={sortedSystems}
                            accountCategory={accountCategory}
						/>
					</Grid>
				</Grid>	

		);
	}
}

const mapStateToProps = (state) => {
	return {
		mobileView: state.dashboard.mobileView,
		systems: state.dashboard.FreeSystems,
		accounts: state.dashboard.accounts,
        accountCategory: state.login.accountCategory
	};
};

const actions = { getFreeSystems, getVisibleAccounts };

export default connect(mapStateToProps, actions)(SettingsPanel);
